export default __webpack_public_path__ + "9834619641b870d647784571524d70b0.png";